import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import * as xml2js from 'xml2js';
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';
import * as environmentUrl from 'src/environments/environment';
import { parseString } from 'xml2js';


@Component({
  selector: 'app-vehicle-sessions-view',
  templateUrl: './vehicle-sessions-view.component.html',
  styleUrls: ['./vehicle-sessions-view.component.scss']
})
export class VehicleSessionsViewComponent implements OnInit {
  ptsUrl = environmentUrl.environment.ptsUrl
  todayDate = Date.now();
  public xmlItems: any;
  vehicleDetails: any;
  indictmentDetails: any;
  diagnosticDetails: any;
  symptomList: any;
  systemSnapshot: any;
  feedbackDisplays: any;
  length: any;
  vehicleValue: any;
  moduleSoftwareDetails: any;
  currentDidList: any;
  optimiseDidList: any;
  dataCollectionDetails: any;
  valueArray1: any;
  valueArray2: any;
  workflowStateDetails: any;
  hardFeaturesData: any;
  vehicleVinData: any;
  dtcList: any;
  dtcError = false
  sessionDetails: any;
  pcmCalibrationFile: any = ' ';
  Odometer: any = '';
  warrantyDate: any;
  xmlData: any;
  diagnosisAvailable = false;
  indictmentAvailable = false;
  warrantyControls: any;
  repairList: any;
  powerTrainSub: any
  powerTrainType: any
  postRepairList: any;
  repairAvailable = false;
  otxDataError = false
  postRepairAvailable = false;
  publicationData: any;
  customerConcern = " ";
  vinAvailable = " ";
  sessionAvailable = true;
  vehicleDetailsAvailable = true;
  moduleDetailsAvailable = true;
  dataCollectionAvailable = true;
  indictmentDataAvailable = true;
  indictmentDataAvailable1 = true;
  indictmentDataAvailable2 = true;
  indictmentFinisCode = true;
  indictmentLabourAvailable = false
  workFlowAvailable = true;
  dealerDetails: any;
  techDetails: any;
  otxData: any
  otxDataAvailable = true
  warrantyKit: any;
  partsListing: any;
  labourTimes: any;
  claimCoding: any;
  sessionError = true;
  failureNote = "";
  partsAvailable = false;
  warrantyAvailable = false;
  labourTimeAvailable = false;
  claimCodingAvilable = true;
  route = ' '
  sbdoService = true
  repairLink: any;
  warrantyControlAvailable = true;
  vinNumber: any;
  repairExecutedAvailable = true;
  repairExecuted: any;
  postrepairExecutedAvailable = true;
  postrepairExecuted: any;
  diaExecutedAvailable = true;
  diaExecuted: any;
  rvcMsg: any = " ";
  wcc: any = " ";
  dMethod: any = " ";
  diagnosisOffered = false;
  noOtxData = false
  sessionClosed = false;
  closedTime: any;
  detailsArray: any = []
  moduleArray: any = []
  public globalManagedRes: any;
  public globalServices: any = [];
  isEnableService = false;
  targetEngineServiceResponseObj: any
  idsFdspEngineServiceResponseObj: any
  ptsEngineServiceResponseObj: any
  fdspEngineServiceResponseObj: any
  repaircount: any = '';
  postcount: any = '';
  details: any
  taskIdArray: any = []
  detailsDataArray: any = []
  currentDidArray: any = []
  detailsData: any = []
  otxHistoryData: any = [];
  detailsError = false
  detailsType = false
  tokenDetails: any
  vin: any
  etisOnlineVersion: any
  targetingEngineVersion: any
  vehicleCommsDLLVersion: any
  vmmVersion: any
  vcmVersion: any
  javaVersion: any
  GFDRS: any
  GFDRSAvail = false
  etisOnlineVersionAvail = false
  targetingEngineVersionAvail = false
  javaVersionAvail = false
  vcmVersionAvail = false
  vmmVersionAvail = false
  vehicleCommsDLLVersionAvail = false
  flashActionError = false
  flashAction: any
  sessionData: any[] = [];
  tokenParamsObj: any;
  otxScreenHistoryDetails: any = [];
  showOTXScreenDetails: boolean = false;
  filterOTXConfig: any = []
  otxdiagnosticConfig: any = []
  otxRepairConfig: any = []
  otxPostRepairConfig: any = []
  finalOtxConfig: any = []
  testExecutedRepair: number = 0;
  testExecutedPostRepair: number = 0;
  repairOTXHistoryDetails: any = [];
  postRepairOTXHistoryDetails: any = [];
  isRepairDetails: boolean = false;
  isPostRepairDetails: boolean = false;
  showhideRepair: any = [];
  showhidePostRepair: any = [];
  isPreviousIndex: boolean = false;
  currentIndex: number = -1;
  previousIndex: number = -1;
  osVersion: string = '';
  osName: string = '';
  memoryInfo: string = '';
  cpuInfo: string = '';
  deviceSerialNo: string = '';
  sessionCloseArray: any = [];
  sessionOpenArray: any = [];
  isSessionCloseTagPresent: boolean = false;
  isSessionOpenTagPresent: boolean = false;
  lastWfsTime: string = '';
  showMultiplesessionTable: boolean = true;
  importedDTC: any;
  showImportedDTCTable: boolean = false;
  printText: string = '';
  @ViewChild('gtacRap') gtacRap: ElementRef | undefined;
  noRVCMsg = 'rvc not required';
  helpdeskMsg = 'Contact Helpdesk'
  BatteryCodes: any;
  BatteryCodeValue: string = '';
  edmMarkets: any = ['AL', 'AM', 'AZ', 'BA', 'BY', 'BG', 'HR', 'CY', 'EE', 'FK', 'GI', 'GE', 'GS', 'KZ', 'LV', 'LT', 'MT', 'MD', 'MK', 'CS', , 'UA', 'TR', 'SI', 'SK', 'CS']
  norvcMsgDec: boolean = false;
  createdTimeStamp: any;
  updatedTimeStamp: any;
  originalDealerCode: string='';
  reassignedDealerCode: any;
  isMobileVan: boolean = false;
  ReassignedUsername: any;
  originalUsername: any;
  alreadyResumedByAnotherUser: boolean = false;
  constructor(private service: ApifirstService, private translate: TranslateService, private modalService: NgbModal, private activateRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe(data => {
      const vin = data['vin']
      const manufacturerId = data['manufacturerId']
      const timeStamp = data['timestamp']
      const sessionSource = data['sessionSource']
      const fromCentralStore = data['fromCentralStore'];
      this.vin = data['vin'],
        this.printText = data['printText'],
        this.service.rapToken.next(data['token']);
      this.tokenParamsObj = {
        "email": data["email"],
        "firstName": data["firstName"],
        "lastName": data["lastName"],
        "username": data["userId"],
        "vin": this.vin,
        "model": data['model'],
        "year": data['year'],
        "country": data['country'],
        "userType": data['userType'],
        "dealerCode": data['dealerCode'],
        "countryThree": data['countryThree'],
        "language": data['language'],
        "marketCountry": data['marketCountry']
      }
      this.vinNumber = data['vin'];
      this.service.tokenObj.next(this.tokenParamsObj)

      this.translate.use(data["language"].toLowerCase());
      // const req = {
      //   "createdTimeStamp": 1633425332000,
      //   "vin": 'WF0FXXWPCFET13888',
      //   "sessionSource": sessionSource,
      //   "manufacturerId": manufacturerId
      // }
      const req = {
        "createdTimeStamp": timeStamp,
        "vin": vin,
        "sessionSource": sessionSource
      }
      console.log(req, "request for xml");
      this.callMobileVanSession(req);
      this.callViewSession(req, fromCentralStore, data["userId"], data['userType']);
    })

    this.showPart('details');
  }
  callMobileVanSession(req: any) {
  console.log("call going to be for mobile van");
  
  this.service.getViewMobileVanSessionInfo(req).subscribe({
    next: (data: any) => {
      // Mapping the response to your component variables
      this.createdTimeStamp = data.originalTimestamp;
      this.updatedTimeStamp = data.reassignedTimestamp;
      this.originalDealerCode = data.originalDealercode;
      this.reassignedDealerCode = data.reassignedDealercode;
      this.isMobileVan = data.isMobileVehicle;
      this.originalUsername = data.originalUsername;
      this.ReassignedUsername = data.reassignedUsername;
      this.alreadyResumedByAnotherUser = data.alreadyResumedByDealer;

      console.log('Session details retrieved successfully', data);
    },
    // Explicitly type 'err' as any to fix the TS7006 error
    error: (err: any) => {
      console.error('Error retrieving mobile van details:', err);
    }
  });
}


  callViewSession(req: any, fromCentralStore: string, userName: string, userType: string) {
    if (fromCentralStore === 'true') {
      this.service.getViewSessionsCentralStore(req).subscribe((data: any) => {
        this.loadXml(data);
      })
    } else {
      this.service.getViewSessions(req, userName, userType).subscribe((data: any) => {
        this.loadXml(data);
      })
    }
  }

  getLastWorkflowStateIfSessionCloseTagNotPresent(data: any) {
    if (data.hasOwnProperty(['workflowState'])) {
      let wfs = data['workflowState'];
      this.lastWfsTime = wfs[wfs.length - 1].$.time;
      this.sessionCloseArray.push({ "state": "suspended", "time": this.lastWfsTime });
    }
  }

  getSessionCloseDetails(data: any) {
    if (data.hasOwnProperty(['sessionClose'])) {
      this.sessionCloseArray.splice(0, 1);
      this.isSessionCloseTagPresent = true;
      let sCloseDetails = data['sessionClose'];
      for (let sc = 0; sc < sCloseDetails.length; sc++) {
        let value = sCloseDetails[sc];
        this.sessionCloseArray.push({ "state": "suspended", "time": value.$.time });
      }
      console.log('Session close Array Before:', this.sessionCloseArray);
      this.sessionCloseArray.push({ "state": "suspended", "time": "nil" });
    }
    console.log('=====================Session Closed Details==============================:', this.sessionCloseArray);
  }

  getSessionOpenDetails(data: any) {
    if (data.hasOwnProperty(['sessionOpen'])) {
      this.isSessionOpenTagPresent = true;
      let sopenedDetails = data['sessionOpen'];
      for (let sOp = 0; sOp < sopenedDetails.length; sOp++) {
        let value = sopenedDetails[sOp];
        this.sessionOpenArray.push(value.$.time);
      }
    }
    console.log('=====================Session Opened Details==============================:', this.sessionOpenArray);
  }

  detailsButtonData(data: any) {
    if (data.hasOwnProperty(['otx:otxConfig'])) {
      this.finalOtxConfig = data['otx:otxConfig']
    }
    for (let d = 0; d < this.filterOTXConfig.length; d++) {
      if (this.filterOTXConfig[d] == 0) {
        let obj = {
          "otx:history": ""
        }
        this.finalOtxConfig.splice(d, 0, obj);
      }
    }
    console.log('---------Final OTX CONFIG----------', this.finalOtxConfig);

    var sum = 0;
    for (let ind = 0; ind < this.sessionData.length; ind++) {
      let testexecutedDiag: number = this.sessionData[ind];
      sum = sum + testexecutedDiag;
    }
    console.log('-----------sum of test executed diagnostic-----------', sum);
    console.log(this.testExecutedRepair, this.testExecutedPostRepair);

    this.otxdiagnosticConfig = this.finalOtxConfig.slice(0, sum);
    this.otxRepairConfig = this.finalOtxConfig.slice(sum, sum + this.testExecutedRepair);
    this.otxPostRepairConfig = this.finalOtxConfig.slice(-this.testExecutedPostRepair);
    this.showHideRepairPostRepairDetailsBtn();
  }

  showHideRepairPostRepairDetailsBtn() {
    for (let r = 0; r < this.otxRepairConfig.length; r++) {
      this.showhideRepair.push(false);
    }
    for (let p = 0; p < this.otxPostRepairConfig.length; p++) {
      this.showhidePostRepair.push(false);
    }
  }

  loadXml(data: any) {
    let item;
    item = document.getElementById('loader');
    if (item) item.style.display = 'none';
    item = document.getElementById('vehicleSessionView');
    if (item) item.style.display = 'block';
    this.xmlData = data
    console.log("xml data");
    console.log(this.xmlData);
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(data, "text/xml");
    console.log('xmlDocument:',xmlDoc);
    let sessionDetails = xmlDoc.getElementsByTagName("session")[0];
    if (sessionDetails) {
      let sessionNodes = sessionDetails.childNodes;
      if (sessionNodes) {
        let testExecuted: number = 0;
        let testOffered: number = -1;
        sessionNodes.forEach((child: any) => {
          if (child.nodeName === 'selectedSymptomList') {
            if (testOffered !== -1) {
              this.sessionData.push(testExecuted);
              testExecuted = 0;
            }
            testOffered++;
          }
          if (child.nodeName === 'diagnosis') {
            testExecuted++;
            this.filterOTXConfig.push(0)
          }

          if (child.nodeName === 'repair') {
            this.testExecutedRepair++
            this.filterOTXConfig.push(0)
          }

          if (child.nodeName === 'postRepair') {
            this.testExecutedPostRepair++
            this.filterOTXConfig.push(0)
          }

          if (child.nodeName === 'otx:otxConfig') {
            this.filterOTXConfig.pop();
            this.filterOTXConfig.push(1);
          }

        })
        if (testOffered !== -1) {
          this.sessionData.push(testExecuted);
        }
      }
      console.log('------------filtered otx-----------', this.filterOTXConfig);
    }
    this.parseXML(this.xmlData).then((data: any) => {
      this.xmlItems = data;  //After parsing
      console.log("parsed");
      console.log(this.xmlItems)
      // Call Details btn function
      this.detailsButtonData(data);
      this.getLastWorkflowStateIfSessionCloseTagNotPresent(data);
      try {
        //sessionOpen data
        let creation = this.xmlItems.creation[0]
        console.log(creation, "creation")
        let sessionArray = {
          "previousSession": creation.$.previousSessionId,
          "sessionOpen": creation.sessionOpen[0].$.time,
          "source": creation.sessionOpen[0].$.sessionSource,
        }
        let dealer = {
          "name": creation.sessionOpen[0].dealer[0].$.name,
          "country": creation.sessionOpen[0].dealer[0].$.dealerMarket,
          "etisCode": creation.sessionOpen[0].dealer[0].$.etisCode
        }
        console.log(dealer, "dealer")
        let technician = {
          "cdsId": creation.sessionOpen[0].technician[0].$.cdsId,
          "country": creation.sessionOpen[0].technician[0].$.countryCode.toUpperCase(),
          "language": creation.sessionOpen[0].technician[0].$.languageCode,
        }
        console.log(technician, "tech")
        console.log(sessionArray);
        this.dealerDetails = dealer;
        this.techDetails = technician;
        this.sessionDetails = sessionArray;
        this.sessionOpenArray.push(creation.sessionOpen[0].$.time);
        this.getSessionCloseDetails(data);
        this.getSessionOpenDetails(data);
        try {
          this.customerConcern = creation.customer[0].concernDescription

        }
        catch {
          this.sessionAvailable = false;
          console.log("no concern")
        }
      }
      catch {
        this.sessionError = false;
        console.log("error")

      }
      try {
        let x = this.xmlItems.vehicleId[0].idData[0].qualifierList[0].qualifier
        for (let i of x) {
          if (i.$.name == "SUBTYPE") {
            this.powerTrainSub = i._
          }
          if (i.$.name == "TYPE") {
            this.powerTrainType = i._
          }
        }
        console.log(this.powerTrainSub, this.powerTrainType, "powerTrain")
      }
      catch {
        console.log("error")
      }
      try {
        if (this.xmlItems.creation[0].sessionOpen[0].$.sessionSource !== "SBDO_Service" && this.xmlItems.creation[0].sessionOpen[0].$.sessionSource != "FORD_ETIS_ONLINE") {
          this.otxDataAvailable = true
          try {
            this.otxData = this.xmlItems['otx:otxConfig'][0]['otx:history'][0]['otx:otxScreen']
            if (this.otxData == null || this.otxData == "" || this.otxData == undefined) {
              this.noOtxData = true
              this.otxDataError = true
            }
          }
          catch {
            this.otxDataError = true
            console.log("error")
          }
        }
        else {
          this.otxDataAvailable = false
        }
      }
      catch {
        this.otxDataError = true
        console.log("error")
      }
      try {
        if (this.xmlItems.creation[0].sessionOpen[0].$.sessionSource == "SBDO_Service") {
          this.sbdoService = true
          try {
            //GetVehicleModelResponse tag
            this.vehicleDetails = this.xmlItems.GetVehicleModelResponse[0].Vehicle[0]
            this.vinAvailable = this.vehicleDetails.VIN[0];
            // for Vehicle Modal data
            this.hardFeaturesData = this.vehicleDetails.HardFeatures[0]


            this.vehicleVinData = this.xmlItems.vehicleId[0].idData[0].VIN[0].$.manualEntry  //vin manual entry
            let dtcListExist: any = this.xmlItems.vehicleId[0].idData[0];
            if (dtcListExist.hasOwnProperty('dtcList')) {
              this.dtcList = this.xmlItems.vehicleId[0].idData[0].dtcList[0]['idstools:dtc'];
              if (this.dtcList == "" || this.dtcList == null || this.dtcList == undefined || this.dtcList.length === 0) {
                this.dtcError = true;
              } else {
                this.dtcError = false;
              }
            } else {
              this.dtcError = true;
            }
            if (dtcListExist.hasOwnProperty('dtcList')) {
              let dtcListCollection = this.xmlItems.vehicleId[0].idData[0].dtcList;
              console.log('DTC Collection List---------------', dtcListCollection);
              if (typeof dtcListCollection[1] != 'undefined') {
                this.showImportedDTCTable = true;
                this.importedDTC = dtcListCollection[1]['idstools:dtc'];
                console.log('----------------Imported------------------------', this.importedDTC);
              }
            }
            for (let p of this.hardFeaturesData.PrimaryFeatureCodes[0].PrimaryFeatureCode) {
              if (p.Key[0] == 'WARRANTY_STARTDATE') {
                console.log("warranty");
                this.warrantyDate = new Date(p.Value[0]);  //warranty date for vehicel modal tag
                console.log(this.warrantyDate)
              }
            }
            let publicationData = this.vehicleDetails.Publications[0].Deliverable
            let keys = []
            for (let i of publicationData) {
              let key = i.VariantID  //deliverable key taken as variantid.
              keys.push(key)
            }
            this.publicationData = keys;
            console.log("Deliverablekey")
            console.log(this.publicationData);

          }
          catch {
            this.vehicleDetailsAvailable = false;
            console.log(this.vehicleDetailsAvailable, "Error vehicle details")
          }
          try {

            //for Module & software
            this.moduleSoftwareDetails = this.vehicleDetails.SoftFeatures[0].VehicleTopology[0].CurrentDiagnosticIdentifierList[0].NodeResponses;
            console.log("Module & software")
            console.log(this.moduleSoftwareDetails)

          }
          catch {
            this.moduleDetailsAvailable = false;
            console.log("Error")
          }

          // for System Snapshot
          try {
            var systemSnapshot: any = [];
            systemSnapshot = this.xmlItems.creation[0].sessionOpen[0].softwareVersionList[0].softwareVersion;
            console.log('------------from view session file----------', systemSnapshot);
            this.GFDRS = systemSnapshot[0].$.version
            this.targetingEngineVersion = systemSnapshot[5].$.version
            this.javaVersion = systemSnapshot[4].$.version
            this.vcmVersion = systemSnapshot[2].$.version
            this.vmmVersion = systemSnapshot[3].$.version
            this.osName = systemSnapshot[11].$.version
            this.osVersion = systemSnapshot[10].$.version
            this.memoryInfo = systemSnapshot[12].$.version
            this.deviceSerialNo = systemSnapshot[13].$.version
            this.cpuInfo = systemSnapshot[14].$.version
          }
          catch {
            console.log("Error")
          }

          // for Feedback Display Using Try & Catch Method
          try {
            //  var r = /\W+/;
            this.feedbackDisplays = this.xmlItems.$['xsi:schemaLocation'].split(".xsd");
            this.length = this.feedbackDisplays.length - 1;
            //  this.feedbackDisplaysOne = this.xmlItems.$['xsi:schemaLocation'].slice(71,98);
            //  this.feedbackDisplaysTwo = this.xmlItems.$['xsi:schemaLocation'].slice(99,154);
            console.log(this.feedbackDisplays, "feedback display")
          }
          catch {
            console.log("Not Available")
          }
        }
        else {
          this.sbdoService = false
          try {
            //GetVehicleModelResponse tag
            this.vehicleDetails = this.xmlItems['vehicle:vehicle'][0]
            console.log(this.vehicleDetails, "vehicle Details")
            this.vinAvailable = this.vehicleDetails['vehicle:vin'][0]['vehicle:vin'][0];

            // for Vehicle Modal data
            this.hardFeaturesData = this.vehicleDetails['vehicle:features'][0]
            console.log(this.hardFeaturesData, "hardfeatures Details")
            this.vehicleVinData = this.xmlItems.vehicleId[0].idData[0].VIN[0].$.manualEntry  //vin manual entry
            let dtcListExist: any = this.xmlItems.vehicleId[0].idData[0];
            if (dtcListExist.hasOwnProperty('dtcList')) {
              this.dtcList = this.xmlItems.vehicleId[0].idData[0].dtcList[0]['idstools:dtc'];
              if (this.dtcList == "" || this.dtcList == null || this.dtcList == undefined || this.dtcList.length === 0) {
                this.dtcError = true;
              } else {
                this.dtcError = false;
              }
            } else {
              this.dtcError = true;
            }

            let z = this.hardFeaturesData['vehicle:primaryFeatures'][0]['vehicle:entry']
            console.log(z, "primaryFeatures")
            for (let p of z) {
              if (p['vehicle:key'][0] == 'WARRANTY_STARTDATE') {
                console.log("warranty");
                this.warrantyDate = new Date(p['vehicle:value'][0]);  //warranty date for vehicel modal tag
                console.log(this.warrantyDate)
              }
            }
            let publicationData = this.vehicleDetails['vehicle:publicationKeys'][0]['vehicle:deliverableKey']
            let keys = []
            for (let i of publicationData) {
              let key = i['vehicle:uid'][0]['vehicle:id'][0]  //deliverable key taken as variantid.
              keys.push(key)
            }
            this.publicationData = keys;
            console.log("Deliverablekey")
            console.log(this.publicationData);

          }
          catch {
            this.vehicleDetailsAvailable = false;
            console.log("Error1")
          }

          try {

            //for Module & software
            this.moduleSoftwareDetails = this.xmlItems.vehicleId[0].idData[0].moduleList[0].module
            console.log("Module & software")
            this.moduleArray = []
            this.currentDidArray = []
            console.log(this.moduleSoftwareDetails)
            this.vehicleValue = this.xmlItems.vehicleId[0].idData[0].vehicleValueList[0].vehicleValue
            console.log(this.vehicleValue, "vehicle Value")
            this.currentDidList = this.xmlItems['vehicle:vehicle'][0]['vehicle:currentTopology'][0]['vehicle:currentDidList']
            this.optimiseDidList = this.xmlItems['vehicle:vehicle'][0]['vehicle:currentTopology'][0]['vehicle:optimisedDidList']
            console.log(this.currentDidList, "currentDidList")
            console.log(this.optimiseDidList, "optimiseDidList")
            if (this.moduleSoftwareDetails != null && this.moduleSoftwareDetails != undefined) {
              for (let i of this.moduleSoftwareDetails) {
                let k = 0
                for (let j of this.vehicleValue) {
                  if (j.$.module == i.$.id) {
                    k = 1
                    this.moduleArray.push(true)
                    break;
                  }

                }
                if (k = 0) {
                  this.moduleArray.push(false)
                }
              }
            }
            console.log(this.moduleArray, "moduleArray")
          }
          catch {
            this.moduleDetailsAvailable = false;
            console.log("Error")
          }

        }
      }
      catch {
        this.moduleDetailsAvailable = false;
        this.vehicleDetailsAvailable = false;
        console.log("error")
      }
      try {
        if (this.xmlItems.creation[0].sessionOpen[0].$.sessionSource == "SBDO_Service") {
          this.flashAction = this.vehicleDetails.SoftFeatures[0].VehicleTopology[0].FlashActions[0].FlashAction
          this.flashActionError = false
          console.log(this.flashAction, "flash")
        }
        else {
          this.flashAction = this.xmlItems['vehicle:vehicle'][0]['vehicle:currentTopology'][0]['vehicle:flashActionList']
          this.flashActionError = false
          console.log(this.flashAction, "flash")
        }
      }
      catch {
        this.flashActionError = true
      }
      try {
        //for Data Collection
        this.dataCollectionDetails = this.xmlItems.vehicleId[0].idData[0].vehicleValueList[0].vehicleValue
        console.log(this.dataCollectionDetails, "data")
        let val1 = [];
        let val2 = [];
        if (this.dataCollectionDetails != undefined) {
          for (let i of this.dataCollectionDetails) {
            if (i.$.module && i.$.name) {
              let ar = [];
              ar.push(i.$.module);
              ar.push(i.$.name);
              ar.push(i._);
              val1.push(ar);
            }
            else {
              let ar = [];
              ar.push(i.$.name);
              ar.push(i._);
              val2.push(ar);
            }
            if (i.$.name == "CM_PCM_FILENAME") {
              this.pcmCalibrationFile = i._; // For Details tag- PCM Calibration file
              console.log(this.pcmCalibrationFile)
            }
            if (i.$.name == "CM_mileage") {
              this.Odometer = i._;
            }
            if (this.Odometer == "") {
              this.Odometer = "(none)"
            }
          }
        }
        else {
          this.Odometer = "(none)"
        }
        this.valueArray1 = val1;
        this.valueArray2 = val2;
        console.log("Data collection")
        console.log(this.valueArray2);
        console.log(this.valueArray1);
      }
      catch {
        this.dataCollectionAvailable = false;
        console.log("error")
      }

      try {
        //For indictment
        let indictmentDetails = this.xmlItems.indictment;
        console.log("Indictment")
        console.log(indictmentDetails)
        if (indictmentDetails) {
          this.indictmentAvailable = true;
          for (let i of indictmentDetails) {
            this.indictmentDetails = i;
            try {
              this.warrantyControls = i.warrantyControl;
            }
            catch {
              this.warrantyControlAvailable = false;
            }
          }
        }
        try {
          this.repaircount = this.indictmentDetails.$.repairInstructionsNumber;
          this.postcount = this.indictmentDetails.$.postRepairInstructionsNumber
        } catch { }
        try {
          let ab = this.indictmentDetails.diagnosticMethod[0].$.value
          this.dMethod = ab;
        }
        catch {
          this.indictmentDataAvailable = false;
        }
        try {
          let cd = this.indictmentDetails.wcc[0].$.value
          this.wcc = cd;
        }
        catch {
          this.indictmentDataAvailable1 = false;
        }
        try {
          let fc = this.indictmentDetails.finisCode[0].$.value
          if (fc == "1111111") {
            this.indictmentLabourAvailable = true
          }
          else {
            this.indictmentLabourAvailable = false
          }
        }
        catch {
          this.indictmentFinisCode = false;
        }
        try {
          let ss = this.indictmentDetails.indictmentCode[0].$.value
          if (ss == 'RVC=0') {
            this.rvcMsg = ""
          }
          else if (ss.toUpperCase() == this.noRVCMsg.toUpperCase()) {
            console.log('RVC MSG------------------', ss);
            this.rvcMsg = 'No RVC Required'
            this.norvcMsgDec = true;
          } else if(ss.toUpperCase() == this.helpdeskMsg.toUpperCase()) {
            this.rvcMsg = 'Contact_Helpdesk'
            this.norvcMsgDec = false;
          } else {
            this.rvcMsg = ss;
            this.norvcMsgDec = false;
          }
        }
        catch {
          this.indictmentDataAvailable2 = false;
        }
        try {
          this.failureNote = this.indictmentDetails.failureNotes[0]
        } catch { }
        try {
          this.route = this.indictmentDetails.payment[0].$.method.substring(0, 1).toUpperCase();
        } catch { }
        try {
          let repairInfo = this.indictmentDetails.repairInformation[0].$
          console.log(repairInfo, "repairInfo")
          let repair = JSON.parse(JSON.stringify(repairInfo));
          console.log(repair, "repair")
          let key = Object.keys(repair);
          console.log(key, "key")
          let value: any;
          for (let i of key) {
            value = repair[i];
          }
          console.log(value, "repair information");
          this.repairLink = value;

        } catch {
        }
        try {
          let parts = this.indictmentDetails.repairInformation[0].partsListing[0].part
          console.log(parts, "parts")
          let partList = []
          for (let i of parts) {
            if (i.$.partNumber !== '0') {
              this.partsAvailable = true;
              partList.push(i.$)
            }
          }
          this.partsListing = partList
          console.log(this.partsListing, "partsListing")
        } catch {
          this.partsAvailable = false;
        }
        try {
          let parts = this.indictmentDetails.repairInformation[0].warrantyKit[0].part
          console.log(parts, "warranty")
          let partList = []
          for (let i of parts) {
            if (i.$.partNumber !== '0') {
              this.warrantyAvailable = true;
              partList.push(i.$)
            }
          }
          this.warrantyKit = partList
          console.log(this.warrantyKit, "warrantyKit")
        } catch {
          this.warrantyAvailable = false;
        }
        try {
          let labour = this.indictmentDetails.repairInformation[0].labourTimes[0].labourTime
          console.log(labour, "labour")
          let labourArray = []
          for (let i of labour) {
            if (i.$.time !== '0') {
              this.labourTimeAvailable = true
              labourArray.push(i.$)
            }
          }
          this.labourTimes = labourArray
          console.log(this.labourTimes, "labourTimes")
        } catch {
          this.labourTimeAvailable = false;
        }
        try {
          this.claimCoding = this.indictmentDetails.repairInformation[0].claimCoding[0].$
          console.log(this.claimCoding, "claimCoding")
        } catch {
          this.claimCodingAvilable = false;
        }
        console.log(this.indictmentDetails, "indictment")
        console.log(this.warrantyControls, "warranty")
      }
      catch {

        console.log("Eroor")
      }

      try {
        //for Workflow
        this.workflowStateDetails = this.xmlItems.workflowState;
        console.log("work flow")
        let workarr = []
        for (let i of this.workflowStateDetails) {
          let val = i.$;
          workarr.push(val)
        }
        this.workflowStateDetails = workarr;
        console.log(this.workflowStateDetails);
        for (let i of this.workflowStateDetails) {
          if (i.title == "sbd.session.state.diagnostic.reception.closed") {
            this.sessionClosed = true;
            this.closedTime = i.time;
            this.sessionCloseArray.splice(this.sessionCloseArray.length - 1, 1); // If session ends remove the nil value in session close array and add the last closed state value.
            this.sessionCloseArray.push({ "state": "closed", "time": i.time });
            if (!this.isSessionCloseTagPresent) {
              this.showMultiplesessionTable = false;
            }
          }
          if (this.sbdoService == false) {
            if (i.title == "sbd.session.state.closed") {
              this.sessionClosed = true;
              this.closedTime = i.time;
            }
          }
        }
      }
      catch {
        this.workFlowAvailable = false;
        console.log("Error")
      }
      try {
        //for Repair
        let repairData = this.xmlItems.repairInstructionList[0].tactic
        let postRepairData = this.xmlItems.postRepairList[0].tactic
        if (repairData) {
          this.repairAvailable = true;
          let repair = [];
          for (let i of repairData) {
            let splitData = i.gradexRule[0].$.gradexId.split("#")
            let nextSplit = splitData[1].split("_")
            let dt = {};
            dt = {
              "seq": i.$.seq,
              "type": i.$.type,
              "resourceId": i.$.resourceId,
              "title": i.$.title,
              "gradexRule": {
                "symptomMap": splitData[0],
                "rule": nextSplit[0],
                "timeStamp": nextSplit[1]
              }
            }
            repair.push(dt);
          }
          this.repairList = repair;
        }
        if (postRepairData) {
          this.postRepairAvailable = true;
          let postrepair = [];
          for (let i of postRepairData) {
            let splitData = i.gradexRule[0].$.gradexId.split("#")
            let nextSplit = splitData[1].split("_")
            let dt = {};
            dt = {
              "seq": i.$.seq,
              "type": i.$.type,
              "resourceId": i.$.resourceId,
              "title": i.$.title,
              "gradexRule": {
                "symptomMap": splitData[0],
                "rule": nextSplit[0],
                "timeStamp": nextSplit[1]
              }
            }
            postrepair.push(dt);
          }
          this.postRepairList = postrepair;
        }
        console.log("Repair");
        console.log(this.repairList);
        console.log(this.postRepairList);

      }
      catch {
        console.log("Error")
      }
      //Tests executed
      try {
        let executed = this.xmlItems.repair
        let postData = []
        for (let i of executed) {
          let ab = {
            "title": i.tacticExecutionStart[0].$.title,
            "seq": i.$.seq,
            "start": i.tacticExecutionStart[0].$.time,
            "end": i.tacticExecutionStop[0].$.time,
            "rId": i.tacticExecutionStart[0].$.resourceId,
            "outcome": i.tacticExecutionStop[0].$.result,
            "type": i.tacticExecutionStart[0].$.type
          }
          postData.push(ab);
        }
        this.repairExecuted = postData;
        console.log("executed")
        console.log(this.repairExecuted)
      }
      catch {
        this.repairExecutedAvailable = false;
      }
      try {
        let executed = this.xmlItems.postRepair
        let postData = []
        for (let i of executed) {
          let ab = {
            "title": i.tacticExecutionStart[0].$.title,
            "seq": i.$.seq,
            "start": i.tacticExecutionStart[0].$.time,
            "end": i.tacticExecutionStop[0].$.time,
            "rId": i.tacticExecutionStart[0].$.resourceId,
            "outcome": i.tacticExecutionStop[0].$.result,
            "type": i.tacticExecutionStart[0].$.type
          }
          postData.push(ab);
        }
        this.postrepairExecuted = postData;
        console.log(" post executed")
        console.log(this.postrepairExecuted)
      }
      catch {
        this.postrepairExecutedAvailable = false;
      }

      try {
        // for Diagonsis
        let symptomList = this.xmlItems.selectedSymptomList;
        console.log(symptomList, "symtoms")
        let symptom: any = [];
        for (let i of symptomList) {
          let diagnosis = [];
          let sym = [];
          diagnosis.push(i.$.seq);
          for (let n of i.gradexSymptom) {
            let sy = {};
            if (n.$.isCategory == "false") {
              sy = {
                "title": n.$.title,
                "gradexId": n.$.gradexId
              }
              sym.push(sy);
            }
          }
          diagnosis.push(sym);
          symptom.push(diagnosis);
        }
        try {
          let diagnosisList = this.xmlItems.diagnosticList;
          console.log(diagnosisList, "diagnosislist")
          if (diagnosisList) {
            this.diagnosisAvailable = true;
            console.log(this.diagnosisAvailable, "diagnosisAvailable");
            for (let p of diagnosisList) {
              let diagnosis = [];
              for (let pr of p.tactic) {
                let splitData = pr.gradexRule[0].$.gradexId.split("#");
                let nextSplit = splitData[1].split("_");
                let dia = {};
                dia = {
                  "seq": pr.$.seq,
                  "type": pr.$.type,
                  "resourceId": pr.$.resourceId,
                  "title": pr.$.title,
                  "gradexRule": {
                    "symptomMap": splitData[0],
                    "rule": nextSplit[0],
                    "timeStamp": nextSplit[1]
                  }
                }
                diagnosis.push(dia);
              }
              symptom[p.$.seq - 1].push(diagnosis);
            }
          }
        } catch {
          //symptom.push(diagnosis);
        }
        try {
          let testOffered = this.xmlItems.diagnosis;
          let otxScreenDetails = this.otxdiagnosticConfig;
          console.log(testOffered, "diagnosis tests")
          if (testOffered) {
            this.diagnosisOffered = true;
            let count: number = 0;
            for (let i = 0; i < this.sessionData.length; i++) {
              let testExecuted: number = this.sessionData[i];
              for (let j = 0; j < testExecuted; j++) {
                let p = testOffered[count];
                let ab = {
                  "title": p.tacticExecutionStart[0].$.title,
                  "seq": p.$.seq,
                  "start": p.tacticExecutionStart[0].$.time,
                  "end": p.tacticExecutionStop[0].$.time,
                  "rId": p.tacticExecutionStart[0].$.resourceId,
                  "outcome": p.tacticExecutionStop[0].$.result,
                  "type": p.tacticExecutionStart[0].$.type
                }

                var screenHistory;
                var screenData: any = []
                if (otxScreenDetails[count]['otx:history'] != "") {
                  if (otxScreenDetails[count]['otx:history'][0].hasOwnProperty(['otx:otxScreen'])) {
                    var ScreenDetails = otxScreenDetails[count]['otx:history'][0]['otx:otxScreen'];
                    for (let k = 0; k < ScreenDetails.length; k++) {
                      var questions;
                      if (ScreenDetails[k].hasOwnProperty('otx:questions')) {
                        questions = ScreenDetails[k]['otx:questions'][0]['otx:question'][0]._
                      } else {
                        questions = ScreenDetails[k]['otx:screenLocation'][0]
                      }
                      screenHistory = {
                        "title": ScreenDetails[k]['otx:screenName'][0],
                        "time": ScreenDetails[k]['otx:time'][0],
                        "outcome": ScreenDetails[k]['otx:outcome'][0].$.returnType,
                        "question": questions,
                        "show": false
                      }
                      screenData.push(screenHistory)
                    }
                  } else {
                    screenHistory = {
                      "title": '',
                      "time": '',
                      "outcome": '',
                      "question": '',
                      "show": false
                    }
                    screenData.push(screenHistory);
                  }
                } else {
                  screenHistory = {
                    "title": '',
                    "time": '',
                    "outcome": '',
                    "question": '',
                    "show": false
                  }
                  screenData.push(screenHistory);
                }

                if (symptom[i][3]) {
                  symptom[i][3].push(ab);
                } else {
                  symptom[i].push([]);
                  symptom[i][3].push(ab);
                }
                if (symptom[i][4]) {
                  symptom[i][4].push(screenData);
                } else {
                  symptom[i].push([]);
                  symptom[i][4].push(screenData);
                }
                if (!symptom[i][5]) {
                  symptom[i].push([]);
                  symptom[i][5].push(0)
                } else {
                  symptom[i][5].push(0)
                }
                count++;
              }
            }
          }
        }
        catch {
          //symptom.push(diagnosis);
        }
        console.log("DIAGONSIS")
        console.log('-------------- Merged List--------------', symptom)
        this.diagnosticDetails = symptom;
      }
      catch {
      }
    });

    this.parseBatteryCodes(data);

  }

  parseBatteryCodes(xmlDoc: any)  {
    parseString(xmlDoc, { explicitArray: false }, (err, result) => {
      if (err) {
        console.error('Error parsing XML', err);
      } else {
        if(result.session['vehicle:vehicle-update'] != undefined) {
          let BatteryResult = result.session['vehicle:vehicle-update']['vehicle:vehicle']['vehicle:evisData']['vehicle:vehicleDataValues']['vehicle:vehicleDataValue']
          this.BatteryCodes = BatteryResult;
          this.BatteryCodeValue = this.BatteryCodes[1]['vehicle:value'];
          console.log('Battery Code Results----------',this.BatteryCodes[1]['vehicle:value']);
        }
      }
    });
  }

  fetchRepairTestExecutedOTXDetails(ind: any) {
    if (this.showhideRepair[ind] == false) {
      this.showhideRepair[ind] = true;
    } else {
      this.showhideRepair[ind] = false;
    }

    for (let r = 0; r < this.showhideRepair.length; r++) {
      if (r !== ind) {
        this.showhideRepair[r] = false;
      }
    }

    this.repairOTXHistoryDetails = [];
    let otxScreenDetails = this.otxRepairConfig;
    var screenHistory;
    if (otxScreenDetails[ind]['otx:history'] != "") {
      if (otxScreenDetails[ind]['otx:history'][0].hasOwnProperty(['otx:otxScreen'])) {
        var ScreenDetails = otxScreenDetails[ind]['otx:history'][0]['otx:otxScreen'];
        for (let k = 0; k < ScreenDetails.length; k++) {
          var questions;
          if (ScreenDetails[k].hasOwnProperty('otx:questions')) {
            questions = ScreenDetails[k]['otx:questions'][0]['otx:question'][0]._
          } else {
            questions = ScreenDetails[k]['otx:screenLocation'][0]
          }
          screenHistory = {
            "title": ScreenDetails[k]['otx:screenName'][0],
            "time": ScreenDetails[k]['otx:time'][0],
            "outcome": ScreenDetails[k]['otx:outcome'][0].$.returnType,
            "question": questions,
            "show": false
          }
          this.repairOTXHistoryDetails.push(screenHistory)
          this.isRepairDetails = true;
        }
      } else {
        screenHistory = {
          "title": '',
          "time": '',
          "outcome": '',
          "question": '',
          "show": false
        }
        this.repairOTXHistoryDetails.push(screenHistory);
        this.isRepairDetails = false;
      }

    } else {
      screenHistory = {
        "title": '',
        "time": '',
        "outcome": '',
        "question": '',
        "show": false
      }
      this.repairOTXHistoryDetails.push(screenHistory);
      this.isRepairDetails = false;
    }
    console.log('-------------repair otx details----------------', this.repairOTXHistoryDetails);
  }

  fetchPostRepairTestExecutedOTXDetails(ind: any) {
    if (this.showhidePostRepair[ind] == false) {
      this.showhidePostRepair[ind] = true;
    } else {
      this.showhidePostRepair[ind] = false;
    }

    for (let p = 0; p < this.showhidePostRepair.length; p++) {
      if (p !== ind) {
        this.showhidePostRepair[p] = false;
      }
    }

    this.postRepairOTXHistoryDetails = []
    let otxScreenDetails = this.otxPostRepairConfig;
    var screenHistory;
    if (otxScreenDetails[ind]['otx:history'] != "") {
      if (otxScreenDetails[ind]['otx:history'][0].hasOwnProperty(['otx:otxScreen'])) {
        var ScreenDetails = otxScreenDetails[ind]['otx:history'][0]['otx:otxScreen'];
        for (let k = 0; k < ScreenDetails.length; k++) {
          var questions;
          if (ScreenDetails[k].hasOwnProperty('otx:questions')) {
            questions = ScreenDetails[k]['otx:questions'][0]['otx:question'][0]._
          } else {
            questions = ScreenDetails[k]['otx:screenLocation'][0]
          }
          screenHistory = {
            "title": ScreenDetails[k]['otx:screenName'][0],
            "time": ScreenDetails[k]['otx:time'][0],
            "outcome": ScreenDetails[k]['otx:outcome'][0].$.returnType,
            "question": questions,
            "show": false
          }
          this.postRepairOTXHistoryDetails.push(screenHistory)
          this.isPostRepairDetails = true;
        }
      } else {
        screenHistory = {
          "title": '',
          "time": '',
          "outcome": '',
          "question": '',
          "show": false
        }
        this.postRepairOTXHistoryDetails.push(screenHistory);
        this.isPostRepairDetails = false;
      }
    } else {
      screenHistory = {
        "title": '',
        "time": '',
        "outcome": '',
        "question": '',
        "show": false
      }
      this.postRepairOTXHistoryDetails.push(screenHistory);
      this.isPostRepairDetails = false;
    }
    console.log('-------------Post repair otx details----------------', this.postRepairOTXHistoryDetails);

  }


  parseXML(data: any) {
    console.log(data)
    return new Promise(resolve => {
      var k: string | number,
        arr = [],
        parser = new xml2js.Parser(
          {
            trim: true,
            explicitArray: true
          });
      parser.parseString(data, function (err: any, result: any) {
        console.log("After parsing");
        var obj = result.session;
        console.log(obj)
        resolve(obj);
      });
    });
  }

  viewProc(id: any, types: any, procUid: any) {
    let fdspToken;
    this.service.rapToken.subscribe((token) => {
      fdspToken = token
    })
    console.log("method called")
    let type: any;
    if (types == "ETIS-CANDIDATE") {
      const path = this.ptsUrl + "transport/?link=700&params=" + this.vinNumber + "&uid=" + id + "&procuid=" + procUid;
      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
    }
    else if (types == "TSB-CANDIDATE") {
      var procUidref = procUid;
      procUidref = procUidref.substring(4);
      procUidref = procUidref.replace("/", "-")
      if (procUidref == "68-2013") {
        procUidref = "068-2013"
      }
      const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
    }
    else {
      if (types == "" || types == "PINPOINT-CANDIDATE" || types == "GENERAL-INFORMATION-CANDIDATE" || types == "REPAIR-INFO-CANDIDATE") {
        type = "SPA"
      }
      else {
        type = "Procedure"
      }
      const path = '/linkDetails' + "?id=" + id + "&type=" + type + "&country=" + this.tokenParamsObj['country'] + "&language=" + this.tokenParamsObj["language"] + "&market=" + this.tokenParamsObj["marketCountry"] + "&userName=" + this.tokenParamsObj["username"] + "&userType=" + this.tokenParamsObj["userType"] + "&token=" + fdspToken + "&printText=" + this.printText;
      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
    }
  }

  showPart(id: any) {
    console.log("Function called");
    var item;

    item = document.getElementById('detailsSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('indictmentSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('diagnosticSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('repairSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('moduleSoftwareSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('systemSnapshotSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('dataCollectionSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('workflowSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('vehicleSection');
    if (item) item.style.display = 'none';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';

    // item = document.getElementById('ctSection');
    // if (item) item.style.display = 'none';

    item = document.getElementById('displayAllSection');
    if (item) item.style.display = 'none';

    item = document.getElementById(id + 'Section');
    if (item) item.style.display = 'block';


    item = document.getElementById('celldetails');
    if (item) item.className = "link";
    item = document.getElementById('celldetailsright');
    if (item) item.className = "right";
    item = document.getElementById('celldetailsleft');
    if (item) item.className = "left";

    item = document.getElementById('cellindictment');
    if (item) item.className = "link";
    item = document.getElementById('cellindictmentright');
    if (item) item.className = "right";
    item = document.getElementById('cellindictmentleft');
    if (item) item.className = "left";

    item = document.getElementById('celldiagnostic');
    if (item) item.className = "link";
    item = document.getElementById('celldiagnosticright');
    if (item) item.className = "right";
    item = document.getElementById('celldiagnosticleft');
    if (item) item.className = "left";

    item = document.getElementById('cellrepair');
    if (item) item.className = "link";
    item = document.getElementById('cellrepairright');
    if (item) item.className = "right";
    item = document.getElementById('cellrepairleft');
    if (item) item.className = "left";

    item = document.getElementById('cellmoduleSoftware');
    if (item) item.className = "link";
    item = document.getElementById('cellmoduleSoftwareright');
    if (item) item.className = "right";
    item = document.getElementById('cellmoduleSoftwareleft');
    if (item) item.className = "left";

    item = document.getElementById('cellsystemSnapshot');
    if (item) item.className = "link";
    item = document.getElementById('cellsystemSnapshotright');
    if (item) item.className = "right";
    item = document.getElementById('cellsystemSnapshotleft');
    if (item) item.className = "left";

    item = document.getElementById('celldataCollection');
    if (item) item.className = "link";
    item = document.getElementById('celldataCollectionright');
    if (item) item.className = "right";
    item = document.getElementById('celldataCollectionleft');
    if (item) item.className = "left";

    item = document.getElementById('cellworkflow');
    if (item) item.className = "link";
    item = document.getElementById('cellworkflowright');
    if (item) item.className = "right";
    item = document.getElementById('cellworkflowleft');
    if (item) item.className = "left";

    item = document.getElementById('cellvehicle');
    if (item) item.className = "link";
    item = document.getElementById('cellvehicleright');
    if (item) item.className = "right";
    item = document.getElementById('cellvehicleleft');
    if (item) item.className = "left";

    item = document.getElementById('cellotx');
    if (item) item.className = "link";
    item = document.getElementById('cellotxright');
    if (item) item.className = "right";
    item = document.getElementById('cellotxleft');
    if (item) item.className = "left";

    // item = document.getElementById('cellct');
    // if (item) item.className = "link";
    // item = document.getElementById('cellctright');
    // if (item) item.className = "right";
    // item = document.getElementById('cellctleft');
    // if (item) item.className = "left";

    item = document.getElementById('celldisplayAll');
    if (item) item.className = "link";
    item = document.getElementById('celldisplayAllright');
    if (item) item.className = "right";
    item = document.getElementById('celldisplayAllleft');
    if (item) item.className = "left";

    var cell = document.getElementById('cell' + id);
    if (cell) cell.className = "selectedLink";
    var cell = document.getElementById('cell' + id + 'right');
    if (cell) cell.className = "selectedRight";
    var cell = document.getElementById('cell' + id + 'left');
    if (cell) cell.className = "selectedLeft";


    // var otxCell = document.getElementById('cellotx');
    // if (otxCell) otxCell.style.display = 'none';
    // var otxCell = document.getElementById('cellotxright');
    // if (otxCell) otxCell.style.display = 'none';
    // var otxCell = document.getElementById('cellotxleft');
    // if (otxCell) otxCell.style.display = 'none';
  }

  showAll() {
    var item;


    item = document.getElementById('detailsSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';


    item = document.getElementById('indictmentSection');
    if (item) item.style.display = 'block';
    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('diagnosticSection');
    if (item) item.style.display = 'block';
    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('repairSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('moduleSoftwareSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('systemSnapshotSection');
    if (item) item.style.display = 'block';

    // item = document.getElementById('otxSection');
    // if (item) item.style.display = 'none';



    item = document.getElementById('dataCollectionSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('workflowSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('vehicleSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    item = document.getElementById('otxSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';



    // item = document.getElementById('ctSection');
    // if (item) item.style.display = 'block';

    // item = document.getElementById('otxSection');
    // if (item) item.style.display = 'none';



    item = document.getElementById('displayAllSection');
    if (item) item.style.display = 'block';

    item = document.getElementById('otxSection');
    if (item) item.style.display = 'none';
  }
  // To get screen details for the executed otx candidate
  showhideOTXDiagnosticDetails(index: any, parentIndex: any) {
  this.otxScreenHistoryDetails = [];
  const parent = this.diagnosticDetails[parentIndex];
  const child = parent[4][index];
  console.log('-----------Array child details-------------', child);
  if (child?.[0]?.title !== '') {
    if (this.diagnosticDetails[parentIndex][5][index] == 0) {
      this.diagnosticDetails[parentIndex][5][index] = 1;
      this.showOTXScreenDetails = true;
    } else {
      this.diagnosticDetails[parentIndex][5][index] = 0;
      this.showOTXScreenDetails = true;
    }

    for (let i = 0; i < child.length; i++) {
      const data = {
        title: child[i].title,
        time: child[i].time,
        outcome: child[i].outcome,
        question: child[i].question,
      };
      this.otxScreenHistoryDetails.push(data);
    }

    // Sort by time (ascending)
    const parseTime = (t: any): number => {
      if (t == null) return 0;
      if (typeof t === 'number') return t;
      const parsed = Date.parse(t);
      return isNaN(parsed) ? 0 : parsed;
    };

    this.otxScreenHistoryDetails = this.otxScreenHistoryDetails
      .slice()
      .sort((a: any, b: any) => parseTime(a.time) - parseTime(b.time));
  } else {
    if (this.diagnosticDetails[parentIndex][5][index] == 0) {
      this.diagnosticDetails[parentIndex][5][index] = 1;
      this.showOTXScreenDetails = false;
    } else {
      this.diagnosticDetails[parentIndex][5][index] = 0;
      this.showOTXScreenDetails = false;
    }
  }

  // assign to 0 for all the indexs except the selected index. To show/hide the diagnostic details btn list.
  for (let d = 0; d < this.diagnosticDetails[parentIndex][5].length; d++) {
    if (d !== index) {
      this.diagnosticDetails[parentIndex][5][d] = 0;
    }
  }

  console.log('---------updated diagnostic list-----------', this.diagnosticDetails);
}


  showhide(id: any, index: any, type: any) {
    this.detailsDataArray = []
    console.log(this.diagnosticDetails[0], "inside")
    this.details = this.diagnosticDetails[0]
    console.log(this.details[3], "details")
    //if (type == "Otx Diagnostic") {
    if (type == 'OTX_DIAGNOSTIC-CANDIDATE') {
      // this.detailsData = this.xmlItems['otx:otxConfig']['otx:history'][0]['otx:otxScreen']
      let otxScreenData = this.xmlItems['otx:otxConfig']
      for (let i in otxScreenData) {
        if (otxScreenData[i]['otx:history'][0]['otx:otxScreen']) {
          var data = otxScreenData[i]['otx:history'][0]['otx:otxScreen']
          for (let j in data) {
            var questions;
            if (data[j].hasOwnProperty('otx:questions')) {
              questions = data[j]['otx:questions'][0]['otx:question'][0]._
            } else {
              questions = data[j]['otx:screenLocation'][0]
            }
            var obj = [{
              "title": data[j]['otx:screenName'][0],
              "time": data[j]['otx:time'][0],
              "outcome": data[j]['otx:outcome'][0].$.returntype,
              "question": questions
            }]
            this.detailsData.push(obj);
          }
          this.otxHistoryData.push(this.detailsData);
          console.log('------------------------otx screen ----------------------', this.otxHistoryData);
        }
        // } else {
        //   this.detailsData.push("No Data Available");
        // }
      }
      console.log(this.detailsData, "details Data")
      if (this.detailsData == null || this.detailsData == "" || this.detailsData == undefined || this.detailsData.length == 0) {
        this.detailsError = true
      }
      else {
        this.detailsError = false
        this.detailsType = false

        for (let j of this.detailsData) {
          // if(j['otx:questions'] != undefined || j['otx:questions'] !=""){
          //   this.detailsDataArray[j] = true
          // }
          // else{
          //   this.detailsDataArray[j] = false
          // }
          // try{
          //   if(j['otx:questions'][0]._ != undefined || j['otx:questions'][0]._ !=""){
          //     this.detailsDataArray[j] = true
          //   }
          //   else{
          //     this.detailsDataArray[j] = false
          //   }
          // }
          // catch{
          //   this.detailsDataArray[j] = true
          // }
          if (j.hasOwnProperty('otx:questions')) {
            this.detailsDataArray.push(true)
            console.log("inside")
          }
          else {
            this.detailsDataArray.push(false)
          }
        }
        console.log(this.detailsDataArray, "detailsDataArray")
      }
    }
    else if (type == "General Information") {
      this.detailsData = this.xmlItems.diagnosis[0].tacticExecutionStop[0].tacticLog[0]['spa:SpaConfig'][0]['spa:history']
      console.log(this.detailsData, "details Data")
      if (this.detailsData == null || this.detailsData == "" || this.detailsData == undefined || this.detailsData.length == 0) {
        this.detailsError = true
      }
      else {
        this.detailsType = true
        this.detailsError = false
      }
    }
    else {
      this.detailsError = true
    }
    // var div = document.getElementById(id);
    // if (div) {
    //   if (div.style.display == 'block')
    //     div.style.display = 'none';
    //   else
    //     div.style.display = 'block';
    // }
    if (this.detailsData == null || this.detailsData == "" || this.detailsData == undefined || this.detailsData.length == 0) {
      this.detailsError = true
    }
    else {
      this.detailsError = false
    }

    for (let i in this.details[3]) {
      this.detailsArray.push(false)
    }
    if (this.taskIdArray.includes(id)) {
      this.taskIdArray = this.taskIdArray.filter((data: any) => {
        return data != id
      })
      // this.prevIndex = index
      for (let i in this.detailsArray) {
        if (i != index) {
          this.detailsArray[i] = false
        }
      }
      this.detailsArray[index] = !this.detailsArray[index]

    }
    else {
      this.taskIdArray.push(id)
      for (let i in this.details[3]) {
        this.detailsArray.push(false)
      }
      this.detailsArray[index] = true
      for (let i in this.detailsArray) {
        if (i != index) {
          this.detailsArray[i] = false
        }
      }
    }
  }
  /** to reporter problem pop up **/
  reportAProblemPopup() {
    if (1 == 1) {
      const modalRef = this.modalService.open(ReportAProblemPageComponent, {
        windowClass: "myCustomModalClass",
        backdrop: 'static'
      });
      modalRef.result.then(
        result => {
          console.log(result);
        },
        reason => { }
      );
    }
  }
  openRapGtacConfirmationPopup() {
    this.modalService.open(this.gtacRap, { size: 'md' });
  }

  contactSubmit(content: any) {
    if (!this.edmMarkets.includes(this.tokenParamsObj.country)) {
      if (this.tokenParamsObj.countryThree == 'ROM') {
        this.tokenParamsObj.countryThree = 'ROU';
      }
      const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.tokenParamsObj.language + '-US&Contactid=&vin=' + this.tokenParamsObj.vin + '&USERID=' + this.tokenParamsObj.username + '&Symptom_codes=12&GEO=' + this.tokenParamsObj.countryThree + '&PACODE=' + this.tokenParamsObj.dealerCode + '&countryCode=' + this.tokenParamsObj.countrythree + '&Model=' + this.tokenParamsObj.vehicle + '&Year=' + this.tokenParamsObj.year, '_blank', 'width=700,height=700');
    }
    else {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static', size: 'md'
      });
    }
  }
}

